class SalutProductFaq extends HTMLElement {
  connectedCallback() {
    this.extra = this.querySelector('[data-extra]');
    this.moreButton = this.querySelector('[data-more]');
    if (!this.extra || !this.moreButton) return;

    this.expanded = false;
    this.moreButton.addEventListener('click', () => this.toggle());
  }

  toggle() {
    this.expanded = !this.expanded;
    this.extra.setAttribute('data-expanded', String(this.expanded));
    this.moreButton.classList.toggle('salut-pfaq__more--open', this.expanded);
    this.moreButton.setAttribute('aria-expanded', String(this.expanded));

    const label = this.moreButton.querySelector('[data-more-label]');
    if (label) {
      label.textContent = this.expanded
        ? this.moreButton.dataset.labelLess
        : this.moreButton.dataset.labelMore;
    }
  }
}

if (!customElements.get('salut-product-faq')) {
  customElements.define('salut-product-faq', SalutProductFaq);
}
